export default "__VITE_ASSET__Ca02fhvj__"